import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { TextField } from '@mui/material';

import ArgonTypography from 'component/Argon/ArgonTypography';
import ArgonBox from 'component/Argon/ArgonBox';
import { addYears, isAfter } from 'date-fns';
import { useEffect } from 'react';

/**
 * @typedef IProps
 * @property {Date|null} value
 * @property {React.Dispatch<Date|null>} setValue
 * @property {boolean} label
 *
 * @param {IProps} props
 */
function PickerPolicyDate({ value, setValue, label = true }) {
  const curDt = new Date();

  return (
    <ArgonBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
      {label && (
        <ArgonBox mb={1} ml={0.5} mt={1} lineHeight={0} display="inline-block">
          <ArgonTypography component="label" variant="caption" fontWeight="bold">
            ระบุวันที่เริ่มต้นความคุ้มครอง
          </ArgonTypography>
        </ArgonBox>
      )}
      <ArgonBox>
        <DesktopDatePicker
          disablePast
          inputFormat="dd-MM-yyyy"
          minDate={curDt}
          // maxDate={addYears(curDt, 1)}
          value={value}
          onChange={(v) => setValue(v)}
          renderInput={(params) => (
            <ArgonBox>
              <TextField
                sx={{
                  '& .MuiInputBase-input.MuiOutlinedInput-input': {
                    width: '100% !important',
                    paddingLeft: '0 !important',
                  },
                }}
                fullWidth
                type="date"
                {...params}
              />
            </ArgonBox>
          )}
        />
      </ArgonBox>
    </ArgonBox>
  );
}

export default PickerPolicyDate;
